import { onTabActive } from '../features/member-center';

app.controller('CouponsController', [
  '$scope',
  'promotionService',
  '$filter',
  '$element',
  '$location',
  'memberGetCouponPopupServices',
  function (
    $scope,
    promotionService,
    $filter,
    $element,
    $location,
    memberGetCouponPopupServices,
  ) {
    const PAGE_SIZE = 5;
    $scope.$filter = $filter;
    $scope.memberPoints = [];
    $scope.pagination = {
      page: 1,
      maxPage: 0,
    };
    $scope.coupons = [];
    $scope.total = {
      comingSoon: 0,
      valid: 0,
      invalid: 0,
    };
    $scope.allTypeCoupons = {
      comingSoon: [],
      valid: [],
      invalid: [],
    };
    $scope.allTypeMaxPage = {
      comingSoon: 0,
      valid: 0,
      invalid: 0,
    };

    var rawOffset = new Date().getTimezoneOffset() / -60;
    $scope.timezoneOffset =
      rawOffset < 0 ? rawOffset : '+' + Math.abs(rawOffset);

    $scope.state = {
      loadingItems: false,
      type: 'valid',
    };

    $scope.setType = function (type) {
      $scope.state.type = type;
      $scope.pagination.page = 1;
      $scope.pagination.maxPage = $scope.allTypeMaxPage[type];
      $scope.coupons = $scope.allTypeCoupons[type].slice(
        0,
        $scope.pagination.page * PAGE_SIZE,
      );
    };

    memberGetCouponPopupServices.openGetCouponPopup({
      type: 'coupon',
      onConfirm: () => {
        const searches = $location.search();
        const couponResult = searches['result'];
        const couponStatus = searches['coupon_status'] || 'valid';
        if (couponResult === 'succeed') {
          $scope.setType(couponStatus);
        }
      },
    });

    const timeFormat = 'YYYY/MM/DD HH:mm';
    const viTimeFormat = 'DD/MM/YYYY HH:mm';
    function getTypeCoupons(type) {
      $scope.state.loadingItems = true;
      promotionService
        .getCoupons(type)
        .then(function (res) {
          $scope.total[type] = res.data.data.total;
          $scope.allTypeMaxPage[type] = Math.ceil(
            res.data.data.total / PAGE_SIZE,
          );
          $scope.allTypeCoupons[type] = _.map(res.data.data.items, function (
            item,
          ) {
            return Object.assign(item, {
              showExpireTag: dayjs(item.end_at).isBefore(dayjs()),
              formattedTime: dayjs(item.end_at).format(
                $scope.mainConfig.localeData.loadedLanguage.code === 'vi'
                  ? viTimeFormat
                  : timeFormat,
              ),
              formattedStartTime: dayjs(item.start_at).format(
                $scope.mainConfig.localeData.loadedLanguage.code === 'vi'
                  ? viTimeFormat
                  : timeFormat,
              ),
            });
          });
          $scope.coupons = $scope.allTypeCoupons[$scope.state.type].slice(
            0,
            $scope.pagination.page * PAGE_SIZE,
          );
          $scope.pagination.maxPage = $scope.allTypeMaxPage[$scope.state.type];
        })
        .finally(function () {
          $scope.state.loadingItems = false;
        });
      // TODO: Add catch error handle
    }

    $scope.getCoupons = function () {
      $scope.pagination.page++;
      $scope.coupons = $scope.allTypeCoupons[$scope.state.type].slice(
        0,
        $scope.pagination.page * PAGE_SIZE,
      );
    };

    $scope.init = function () {
      _.forEach(['comingSoon', 'valid', 'invalid'], function (type) {
        getTypeCoupons(type);
      });
    };

    $scope.init();

    onTabActive($element, () => {
      history.replaceState(null, null, `coupons${location.search}`);
    });
  },
]);
